// Zand Bank 渠道专属参数覆盖、描述、示例
// 选中 ZAND_BANK 渠道时覆盖通用定义，仅当 selectedChannel === 'ZAND_BANK' 时生效。

export const ZAND_BANK_PARAM_OVERRIDES = {
  ACCOUNT_CREATE: {
    request: [
      { name: 'requestId', label: '请求ID', type: 'STRING', required: true, maxLen: 64 },
      { name: 'channelCode', label: '渠道代码', type: 'ENUM', required: true, tip: 'ZAND_BANK' },
      { name: 'externalUserId', label: '外部用户ID', type: 'STRING', required: true, maxLen: 64 },
      { name: 'currency', label: '币种', type: 'ENUM', required: true, tip: '仅支持 AED' },
      { name: 'userType', label: '用户类型', type: 'ENUM', required: true, tip: 'INDIVIDUAL / BUSINESS' },
      { name: 'paymentMethod', label: '支付方式', type: 'ENUM', required: true, tip: '仅 VIRTUAL_ACCOUNT' },
      { name: 'extParam', label: '扩展参数', type: 'JSON_STRING', required: true, tip: '必填，JSON 格式字符串；INDIVIDUAL 需 nationality + dateOfBirth；BUSINESS 需 licenseIssuer' },
    ],
    response: [
      { name: 'accountId', label: '账户ID', type: 'STRING', required: true },
      { name: 'channelAccountId', label: '渠道账户ID', type: 'STRING', required: false, tip: 'Zand 内部 AccountId' },
      { name: 'currency', label: '币种', type: 'STRING', required: true },
      { name: 'status', label: '状态', type: 'STRING', required: true, tip: 'ACTIVE / FAILED' },
      { name: 'errorCode', label: '错误码', type: 'STRING', required: false },
      { name: 'errorMsg', label: '错误信息', type: 'STRING', required: false },
    ],
  },
  ACCOUNT_QUERY: {
    response: [
      { name: 'accountId', label: '账户ID', type: 'STRING', required: true },
      { name: 'userType', label: '用户类型', type: 'STRING', required: true, tip: 'INDIVIDUAL / BUSINESS' },
      { name: 'status', label: '账户状态', type: 'STRING', required: true, tip: 'ACTIVE / FAILED / CLOSED' },
      { name: 'subStatus', label: '子状态', type: 'STRING', required: true, tip: 'SUCCESS / FAILED' },
      { name: 'channelCode', label: '渠道', type: 'STRING', required: true },
      { name: 'currency', label: '币种', type: 'STRING', required: true },
      { name: 'externalUserId', label: '外部用户ID', type: 'STRING', required: true },
      { name: 'paymentMethod', label: '支付方式', type: 'STRING', required: true },
      { name: 'createTime', label: '创建时间', type: 'LONG', required: true },
      { name: 'updateTime', label: '更新时间', type: 'LONG', required: true },
      {
        name: 'accountDetail', label: '账户详情', type: 'OBJECT', required: false, tip: '开户成功时返回',
        children: [
          { name: 'accountName', label: '账户名', type: 'STRING', required: false },
          { name: 'accountNumber', label: 'VA IBAN', type: 'STRING', required: true, tip: '格式如 AE900961002923020000004' },
          { name: 'bic', label: 'SWIFT Code', type: 'STRING', required: false },
          { name: 'bankName', label: '银行名称', type: 'STRING', required: false },
          { name: 'bankCountry', label: '银行国家', type: 'STRING', required: false },
          { name: 'bankAddress', label: '银行地址', type: 'STRING', required: false },
          { name: 'beneficiaryVaNo', label: 'VA 编号', type: 'STRING', required: false, tip: 'Zand 内部 VA 编号' },
        ],
      },
    ],
  },
  CARD_BIND: {
    request: [
      { name: 'requestId', label: '请求ID', type: 'STRING', required: true, maxLen: 64 },
      { name: 'channelCode', label: '渠道代码', type: 'ENUM', required: true, tip: 'ZAND_BANK' },
      { name: 'externalUserId', label: '外部用户ID', type: 'STRING', required: true, maxLen: 64 },
      { name: 'accountId', label: '账户ID', type: 'STRING', required: true, tip: '开户返回的 accountId，须为 ACTIVE 状态' },
      { name: 'userType', label: '用户类型', type: 'ENUM', required: true, tip: 'INDIVIDUAL / BUSINESS，须与开户时一致' },
      { name: 'accountName', label: '收款人名称', type: 'STRING', required: true, maxLen: 75, tip: '须含名与姓（空格分隔）' },
      { name: 'iban', label: '收款人 IBAN', type: 'STRING', required: true, tip: 'UAE IBAN 格式: AE + 21 位数字' },
      { name: 'currency', label: '币种', type: 'ENUM', required: true, tip: '仅支持 AED' },
      { name: 'bankName', label: '银行名称', type: 'STRING', required: false },
      { name: 'bankCountry', label: '银行国家', type: 'STRING', required: false, tip: '如 AE' },
    ],
    response: [
      { name: 'recipientId', label: '绑卡ID', type: 'STRING', required: true },
      { name: 'status', label: '状态', type: 'STRING', required: true, tip: 'SUCCESS' },
    ],
  },
  CARD_QUERY: {
    response: [
      { name: 'recipientId', label: '绑卡ID', type: 'STRING', required: true },
      { name: 'channelCode', label: '渠道编码', type: 'STRING', required: true },
      { name: 'externalUserId', label: '外部用户ID', type: 'STRING', required: true },
      { name: 'accountId', label: '账户ID', type: 'STRING', required: true },
      { name: 'userType', label: '用户类型', type: 'STRING', required: true },
      { name: 'accountName', label: '收款人名称', type: 'STRING', required: true },
      { name: 'iban', label: '收款人 IBAN', type: 'STRING', required: true },
      { name: 'currency', label: '币种', type: 'STRING', required: true },
      { name: 'bankName', label: '银行名称', type: 'STRING', required: false },
      { name: 'bankCountry', label: '银行国家', type: 'STRING', required: false },
      { name: 'status', label: '状态', type: 'STRING', required: true, tip: 'SUCCESS' },
      { name: 'createTime', label: '创建时间', type: 'LONG', required: false },
      { name: 'updateTime', label: '更新时间', type: 'LONG', required: false },
    ],
  },
  DEPOSIT_QUERY: {
    response: [
      { name: 'orderId', label: '订单号', type: 'STRING', required: true },
      { name: 'externalOrderId', label: '外部订单号', type: 'STRING', required: false },
      { name: 'channelOrderId', label: '渠道订单号', type: 'STRING', required: false },
      { name: 'status', label: '状态', type: 'STRING', required: true, tip: 'SUCCESS / FAILED' },
      { name: 'subStatus', label: '子状态', type: 'STRING', required: true, tip: 'NO_REFUND' },
      { name: 'accountId', label: '账户ID', type: 'STRING', required: true },
      { name: 'depositMethod', label: '充值方式', type: 'STRING', required: true, tip: 'VIRTUAL_ACCOUNT' },
      { name: 'channelCode', label: '渠道', type: 'STRING', required: true },
      { name: 'currency', label: '币种', type: 'STRING', required: true },
      { name: 'amount', label: '金额', type: 'STRING', required: true },
      { name: 'fee', label: '手续费', type: 'STRING', required: true },
      { name: 'createTime', label: '创建时间', type: 'STRING', required: true },
      { name: 'updateTime', label: '更新时间', type: 'STRING', required: false },
      { name: 'completedTime', label: '完成时间', type: 'STRING', required: false },
      {
        name: 'senderInfo', label: '付款人信息', type: 'OBJECT', required: false, tip: '入金付款方信息',
        children: [
          { name: 'senderAcctNo', label: '付款方账号', type: 'STRING', required: false },
          { name: 'senderAcctName', label: '付款方名称', type: 'STRING', required: false },
          { name: 'iban', label: '付款方 IBAN', type: 'STRING', required: false },
        ],
      },
      {
        name: 'receiverInfo', label: '收款人信息', type: 'OBJECT', required: false, tip: '入金收款方（VA）信息',
        children: [
          { name: 'accountName', label: '账户名', type: 'STRING', required: false },
          { name: 'iban', label: 'VA IBAN', type: 'STRING', required: false },
        ],
      },
    ],
  },
  WITHDRAW_CREATE: {
    request: [
      { name: 'requestId', label: '请求ID', type: 'STRING', required: true, maxLen: 64 },
      { name: 'channelCode', label: '渠道代码', type: 'ENUM', required: true, tip: 'ZAND_BANK' },
      { name: 'externalUserId', label: '外部用户ID', type: 'STRING', required: true, maxLen: 64 },
      { name: 'externalOrderId', label: '外部订单号', type: 'STRING', required: true, maxLen: 256, tip: '幂等 key' },
      { name: 'accountId', label: '账户ID', type: 'STRING', required: true, tip: '出金来源 VA 的 accountId' },
      { name: 'currency', label: '币种', type: 'ENUM', required: true, tip: '仅支持 AED' },
      { name: 'amount', label: '金额', type: 'DECIMAL', required: true, tip: '正数；Zand 按金额自动选清算通道: <=50000 走 IPI, >50000 走 FTS' },
      { name: 'withdrawMethod', label: '提现方式', type: 'ENUM', required: true, tip: '仅 BANK_TRANSFER（Domestic Transfer）' },
      { name: 'callbackUrl', label: '回调地址', type: 'STRING', required: true, maxLen: 2048, tip: '必须以 http:// 或 https:// 开头' },
      { name: 'extParam', label: '扩展参数', type: 'JSON_STRING', required: true, tip: '必填，JSON 格式字符串，含 recipientId / remarks / paymentPurposeCode / reference(可选)', children: [
        { name: 'recipientId', label: '收款人 ID', type: 'STRING', required: true, tip: '绑卡返回的 recipientId' },
        { name: 'remarks', label: '客户备注', type: 'STRING', required: true, tip: 'RemittanceInformation.Unstructured，最长 140 字符' },
        { name: 'reference', label: '参考号', type: 'STRING', required: false, tip: 'RemittanceInformation.Reference，可选，最长 40 字符，仅允许字母数字和连字符' },
        { name: 'paymentPurposeCode', label: '支付目的码', type: 'STRING', required: true, tip: '3位大写字母(^[A-Z]{3}$)；<=50000 AED 用 IPI 码表(34个，常用: SAL(工资)/INS(保险费)/EDU(教育)/RNT(租金)/COM(佣金)/TAX(税费)/UTL(水电费)/FIS(金融服务)/DIV(股息)/GDS(商品购销)/MCR(医疗费)/SVP(服务费)/IGT(集团内转账))；>50000 AED 用 FTS 码表(110个，含 IPI 全部码 + 扩展码)' },
      ] },
    ],
    response: [
      { name: 'orderId', label: '订单号', type: 'STRING', required: true },
      { name: 'status', label: '状态', type: 'STRING', required: true, tip: 'PROCESSING（异步处理，最终状态通过 webhook 回调）' },
    ],
  },
  BALANCE_QUERY: {
    request: [
      { name: 'requestId', label: '请求ID', type: 'STRING', required: false },
      { name: 'channelCode', label: '渠道代码', type: 'ENUM', required: true, tip: 'ZAND_BANK' },
      { name: 'currency', label: '币种', type: 'STRING', required: true, tip: '仅支持 AED' },
    ],
    response: [
      { name: 'channelAccountNo', label: '渠道账户号', type: 'STRING', required: true },
      { name: 'channelCode', label: '渠道编码', type: 'STRING', required: true },
      { name: 'currency', label: '币种', type: 'STRING', required: true },
      { name: 'availableBalance', label: '可用余额', type: 'STRING', required: true },
    ],
  },
};

export const ZAND_BANK_API_DESC = {
  ACCOUNT_CREATE: '创建 Zand Bank 虚拟账户（VA），同步返回结果。开户成功后自动绑定 whitelistIbans 入金白名单。仅支持 AED。',
  ACCOUNT_QUERY: '查询 Zand Bank 账户状态和详情，开户成功后可获取 VA IBAN（accountDetail.accountNumber）。',
  CARD_BIND: '绑定收款人 IBAN 到 Zand Bank 白名单。幂等字段: businessPartner + channelCode + externalUserId + userType + currency + iban。',
  CARD_QUERY: '查询 Zand Bank 绑卡（收款人白名单）状态和详情。',
  WITHDRAW_CREATE: '从用户 VA 向外部收款人发起境内转账（Domestic Transfer）。异步处理，最终状态通过 webhook 回调。',
  WITHDRAW_QUERY: '查询 Zand Bank 提现订单状态。',
  DEPOSIT_QUERY: '查询 Zand Bank 充值订单。入金通过 Zand webhook 驱动，无需上游主动创建。',
  BALANCE_QUERY: '查询 Zand Bank 渠道账户余额。仅支持 AED。',
};

export const ZAND_BANK_API_EXAMPLES = {
  ACCOUNT_CREATE: {
    request: {
      requestId: 'REQ-ZB-VA-0003',
      channelCode: 'ZAND_BANK',
      externalUserId: 'user-001',
      currency: 'AED',
      userType: 'INDIVIDUAL',
      paymentMethod: 'VIRTUAL_ACCOUNT',
      extParam: '{"accountName":"John Smith","type":"INDIVIDUAL","nationality":"UAE","dateOfBirth":"1990-05-15","identifierDocuments":[{"type":"EID","number":"784199012345671","expiryDate":"2030-12-31"}],"whitelistIbans":["AE420961000443010000001"]}',
    },
    response: {
      code: 200, subCode: '000000', msg: 'Success', requestId: 'REQ-ZB-VA-0003',
      data: { accountId: 'AC20260810ZB00000119', channelAccountId: '1002923020000004', currency: 'AED', status: 'ACTIVE', errorCode: null, errorMsg: null },
    },
  },
  ACCOUNT_QUERY: {
    request: { accountId: 'AC20260810ZB00000119', requestId: 'REQ-QUERY-001' },
    response: {
      code: 200, subCode: '000000', msg: 'Success', requestId: 'REQ-QUERY-001',
      data: {
        accountId: 'AC20260810ZB00000119', userType: 'BUSINESS', status: 'ACTIVE', subStatus: 'SUCCESS',
        channelCode: 'ZAND_BANK', currency: 'AED', externalUserId: 'user-zb-biz-001', paymentMethod: 'VIRTUAL_ACCOUNT',
        createTime: 1786337994014, updateTime: 1786344798351,
        accountDetail: {
          accountName: 'ACME TRADING LLC', accountNumber: 'AE900961002923020000004',
          bic: null, bankName: null, bankCountry: null, bankAddress: null,
          beneficiaryVaNo: '1002923020000004',
        },
      },
    },
  },
  CARD_BIND: {
    request: {
      requestId: 'REQ-ZB-CARD-001', channelCode: 'ZAND_BANK', externalUserId: 'user-zb-001',
      accountId: 'AC20260807ZB00000120', userType: 'BUSINESS', accountName: 'Fintech DEV',
      iban: 'AE610030000053285920001', currency: 'AED', bankName: 'Mashreq Bank', bankCountry: 'AE',
    },
    response: {
      code: 200, subCode: '000000', msg: 'Success', requestId: 'REQ-ZB-CARD-001',
      data: { recipientId: 'RC20260811ZB00000001', status: 'SUCCESS' },
    },
  },
  CARD_QUERY: {
    request: { requestId: 'REQ-QUERY-001', recipientId: 'RC20260811ZB00000001' },
    response: {
      code: 200, subCode: '000000', msg: 'Success', requestId: 'REQ-QUERY-001',
      data: {
        recipientId: 'RC20260811ZB00000001', channelCode: 'ZAND_BANK', externalUserId: 'user-zb-001',
        accountId: 'AC20260807ZB00000120', userType: 'BUSINESS', accountName: 'Fintech DEV',
        iban: 'AE610030000053285920001', currency: 'AED', bankName: 'Mashreq Bank', bankCountry: 'AE',
        status: 'SUCCESS', createTime: 1723365600000, updateTime: 1723365600000,
      },
    },
  },
  DEPOSIT_QUERY: {
    request: { requestId: 'REQ-DEP-QUERY-001', orderId: 'DP20260810ZB00000152' },
    response: {
      code: 200, subCode: '000000', msg: 'Success', requestId: 'REQ-DEP-QUERY-001',
      data: {
        accountId: 'AC20260810ZB00000119', amount: '50000.00', channelCode: 'ZAND_BANK',
        channelOrderId: 'ZDD6614587783652', completedTime: '1787045720465', createTime: '1787045702907',
        currency: 'AED', depositMethod: 'VIRTUAL_ACCOUNT', externalOrderId: 'DP20260818ZB00000097',
        fee: '0.00', orderId: 'DP20260818ZB00000097',
        receiverInfo: { accountName: 'ACME TRADING LLC', iban: 'AE900961002923020000004' },
        refundStatus: 'NO_REFUND',
        senderInfo: { iban: 'AE610030000053285920001', senderAcctName: 'Fintech DEV', senderAcctNo: 'AE610030000053285920001' },
        status: 'SUCCESS', subStatus: 'SUCCESS', updateTime: '1787045720469',
      },
    },
  },
  WITHDRAW_CREATE: {
    request: {
      requestId: 'REQ-ZB-WD-001', channelCode: 'ZAND_BANK', externalUserId: 'user-zb-001',
      externalOrderId: 'EXT-WD-20260810-001', accountId: 'AC20260807ZB00000120', currency: 'AED',
      amount: '100.00', withdrawMethod: 'BANK_TRANSFER', callbackUrl: 'https://merchant.com/callback',
      extParam: '{"recipientId":"RC20260811ZB00000001","remarks":"Payment for services","reference":"PAY-REF-001","paymentPurposeCode":"FIS"}',
    },
    response: {
      code: 200, subCode: '000000', msg: 'Success', requestId: 'REQ-ZB-WD-001',
      data: { orderId: 'WD20260810ZB00000001', status: 'PROCESSING' },
    },
  },
  WITHDRAW_QUERY: {
    request: { requestId: 'REQ-WD-QUERY-001', orderId: 'WD20260810ZB00000001' },
    response: {
      code: 200, subCode: '000000', msg: 'Success', requestId: 'REQ-WD-QUERY-001',
      data: {
        orderId: 'WD20260810ZB00000001', externalOrderId: 'EXT-WD-20260810-001', channelOrderId: 'ZDD1234567890123',
        status: 'SUCCESS', subStatus: 'SUCCESS', withdrawMethod: 'BANK_TRANSFER', channelCode: 'ZAND_BANK',
        currency: 'AED', amount: 500.00, fee: 0, feeCurrency: 'AED',
        createTime: 1786350000000, updateTime: 1786350060000, completedTime: 1786350060000,
        errorCode: null, errorMsg: null,
      },
    },
  },
  BALANCE_QUERY: {
    request: { requestId: 'REQ-BAL-001', channelCode: 'ZAND_BANK', currency: 'AED' },
    response: {
      code: 200, subCode: '000000', msg: 'Success', requestId: 'REQ-BAL-001',
      data: [{ channelAccountNo: '1002923010000005', channelCode: 'ZAND_BANK', currency: 'AED', availableBalance: '92.60' }],
    },
  },
};
